import React, { useState, useEffect } from 'react';
import { MessageCircle, Sparkles, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import AlphaModal from '@/features/alpha/components/AlphaModal';
import './Tooltip.css';

const AlphaIcon: React.FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Ctrl+K: toggle the Alpha modal open/closed
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'k') {
        event.preventDefault();
        setIsModalOpen((prev) => !prev);
        setShowTooltip(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      {!isModalOpen && (
        <div
          className="fixed bottom-4 right-2 z-50"
          onMouseEnter={() => setShowTooltip(true)}
        >
          <div className="relative">
            {showTooltip && (
              <div className="group tooltip-custom absolute bottom-0 right-20 w-max">
                <button
                  onClick={() => setShowTooltip(false)}
                  className="absolute -top-2 -left-2 rounded-full bg-header p-1 text-on-primary opacity-0 group-hover:opacity-100"
                >
                  <X size={16} />
                </button>
                <div className="sparkle-icon-background">
                  <Sparkles size={24} className="text-white" />
                </div>
                <div>
                  <p className="meet-alpha-text">{t('alpha.meetAlpha')}</p>
                  <p className="tooltip-description">
                    {t('alpha.meetAlphaDescription')}
                  </p>
                </div>
              </div>
            )}
            <button
              onClick={() => {
                setIsModalOpen(true);
                setShowTooltip(false);
              }}
              className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-on-primary shadow-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 hover:bg-header animate-gentle-bounce"
              aria-label={t('alpha.openChat')}
            >
              <MessageCircle size={32} />
            </button>
          </div>
        </div>
      )}
      {isModalOpen && <AlphaModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};

export default AlphaIcon;